/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./packetList.vue?vue&type=template&id=36cb88b4&scoped=true&"
import script from "./packetList.vue?vue&type=script&lang=js&"
export * from "./packetList.vue?vue&type=script&lang=js&"
import style0 from "./packetList.vue?vue&type=style&index=0&id=36cb88b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cb88b4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCol,VIcon,VRow,VSimpleTable})
